var lists_default = {
  "fontElementMap": "bRwXW",
  "orderedlist": "R7J7P",
  "bulletedlist": "dzvx4",
  "listItem": "OYWfA"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
